import { TGetCompanyMembersResponse } from '@commenda/types/src/company/types';
import { SWRFetcher } from '@commenda/utils';
import { UserEntityLinkRole } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';

export default function useCompanyMembers(companyId: number | string, includeAgentMembers = false) {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data?: TGetCompanyMembersResponse;
    error?: unknown;
    isLoading: boolean;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `company/${companyId}/members`,
    SWRFetcher({
      method: 'GET',
    })
  );

  if (!includeAgentMembers) {
    const filteredMembers = data?.members?.filter((member) => member.role !== UserEntityLinkRole.AGENT_PORTAL_USER) || [];
    const count = filteredMembers.length;

    return {
      data: {
        members: filteredMembers,
        count,
      },
      error,
      isLoading,
      mutate
    }
  }

  return {
    data,
    error,
    isLoading,
    mutate,
  };
}
